import { IState } from "angular-ui-router";

export const shaasParentRoute = 'shaas';

export const shaasRoutes:IState[] = [{
	name: 'shaas.configureShare',
	parent: shaasParentRoute,
	url: '/shares/:shareId/configure?access',
	template: params => {
		return `<shaas-configure-share share-id='${params.shareId}'></shaas-configure-share>`;
	}
}, {
	name: 'shaas.manageShares',
	parent: shaasParentRoute,
	url: '/shares?access',
	template: params => {
		return `<shaas-manage-shares></shaas-manage-shares>`;
	}
}];


// WEBPACK FOOTER //
// ./src/shaas/shaas.routes.ts